<template>
  <div class="zmanim-nav__container">
    <zmanim-logo
      :live="true"
      :seconds="seconds"
      @click.native="seconds = !seconds"
    />
    <div class="zmanim-nav__links">
      <router-link class="zmanim-nav__link" to="/about/faq">FAQs</router-link>
      <router-link class="zmanim-nav__link" to="/about/privacy"
        >Privacy</router-link
      >
      <router-link class="zmanim-nav__link" to="/support">Support</router-link>
      <a :href="appStore.link" class="zmanim-nav__cta" target="_blank"
        >Download</a
      >
    </div>
  </div>
</template>

<script>
import AppStore from '@/lib/appStore'
import { appId } from '@/config'

import ZmanimLogo from './ZmanimLogo'

export default {
  name: 'ZmanimNavigation',
  components: {
    ZmanimLogo
  },
  data () {
    return {
      appStore: new AppStore({ appId }),
      seconds: false
    }
  }
}
</script>

<style scoped>
.zmanim-nav__container {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  z-index: 99;
  transition: all 300ms ease;
}

@media screen and (min-width: 850px) {
  .zmanim-nav__container {
    height: 5.63rem;
    margin: 0.88rem 0 0 0;
    padding: 0;
  }

  .zmanim-nav__link {
    font-size: 1.25rem;
    padding: auto 0.94rem;
  }
}

@media screen and (max-width: 850px) {
  .zmanim-nav__container {
    flex-direction: column;
  }

  .zmanim-nav__link {
    font-size: 1rem;
  }
}

@media screen and (max-width: 414px) {
  .zmanim-nav__link {
    padding-left: 0;
    padding-right: 0;
    font-size: 0.75rem;
  }
}

.zmanim-nav__link {
  text-decoration: none;
  font-family: "Avenir-Heavy";
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  cursor: pointer;
  transition: all 300ms ease;
}

.zmanim-nav__links a {
  text-decoration: none;
  border-radius: 0.625rem;
  cursor: pointer;
  transition: all 300ms ease;
  padding: 0.47rem 0.94rem;
  border: 2px solid #ffffff00;
  transform: scale(1);
}

.zmanim-nav__links a:hover {
  box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.15);
  border: 2px solid #000;
  transform: scale(1.2);
}

.zmanim-nav__link::selection {
  background: rgba(255, 133, 17, 0.3);
}

.zmanim-nav__cta {
  cursor: pointer;
  font-family: "Avenir-Heavy";
  font-size: 1.25rem;
  color: #ff8511;
  letter-spacing: 0;
  margin-right: 0;
}

.zmanim-nav__links .zmanim-nav__cta:hover {
  border-color: #ff8511;
}

.zmanim-nav__cta::selection {
  background: rgba(0, 0, 0, 0.3);
}
</style>
